<template>
    <div class="tracker-container">
        <div class="tracker">
            <div class="texts">
                <div class="section" v-for="item in tabItems" :key="item.title">
                    <p>{{ item.title }}</p>
                    <div :class="item.active ? 'default-status active' : 'default-status'"></div>
                </div>
            </div>
            <div class="progress-container">
                <div
                    class="progress-bar"
                    :style="{height: 'inherit', background: '#4AEB76', borderRadius: '9px', width: `${getProgressPercent}%`}"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OnboardingProgressTracker",
    props: [ "tabItems" ],
    computed: {
        getProgressPercent() {
            let percent;
            this.tabItems.map(item => {
                if (item.path == this.$route.path) percent = item.percent;
            })
            return percent;
        }
    },
    data() {
        return {
            setActivePoints() {
                let activeStatus = true;
                let itemsArray = this.tabItems
                itemsArray.map(item => {
                    item.active = activeStatus;
                    if (item.path == this.$route.path) activeStatus = false;
                })
                this.tabItems = itemsArray;
            }
        }
    },
    beforeMount() {
        this.setActivePoints();
    },
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/_reduced_variables.scss";

h1, h2, h3, h4, p {
    margin: 0;
    padding: 0;
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
}

.tracker-container {
    margin-bottom: 30px;
}

.texts {
    display: flex;
    justify-content: space-between;

    .section {
        text-align: center;
        position: relative;

        p {
            color: #727272;
            font-size: 12px;
            line-height: 16px;
            font-weight: bold;
            margin-bottom: 9px;
        }

        .default-status {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #EFEFEF;
            display: inline-block;
            position: absolute;
            bottom: -9px;
        }

        div.active {
            background: #4AEB76;
        }

        &:first-child {
            text-align: left;
            margin-left: -3px;
        }

        &:last-child {
            text-align: right;
            margin-right: 3px;
        }
    }
}

.progress-container {
    background: #EFEFEF;
    height: 7px;
    border-radius: 9px;

    .progress-status {
        background: #4AEB76;
        /* width: 32.5%; */
        height: inherit;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/OnboardingProgressTracker.vue